import { useEffect, useState } from "react";
import { Box, Button, Grid, useTheme, useMediaQuery, Alert, Dialog, DialogContent } from "@mui/material";
import axios from 'axios';
import { URL, getDataInfo, getRequestAccess, setDataInfo } from "../helper";
import ItemBox from "../components/ItemBox";
import FormItem from "../components/FormItem";
import ShowItem from "../components/ShowItem";

function Home() {
  const [data, setData] = useState([]);
  const theme = useTheme();
  const xs = useMediaQuery(theme.breakpoints.only('xs'));

  const [isCreate, setIsCreate] = useState(true);

  const [openSlide, setOpenSlide] = useState(false);
  const [isEditN, setIsEditN] = useState(false);

  const [itemEdit, setItemEdit] = useState({});
  const [itemDelete, setItemDelete] = useState({});
  const [isConfirm, setIsConfrim] = useState(false);

  const [isError, setIsError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [counter, setCounter] = useState(0);

  const [isError2, setIsError2] = useState(false);
  const [isSuccess2, setIsSuccess2] = useState(false);

  useEffect(() => {
    checkInfo();
  }, [])

  const checkInfo = async () => {
    const info = getDataInfo();
    if (info) {
      const token = info?.token;
      axios.defaults.headers.common['token'] = token;
      axios.post(URL.getInfo).then((res) => {
        if (res?.status === 200) {
          if (res?.data?.result === "complete") {
            getListSlide();
          } else {
            goToLogin();
          }
        } else {
          goToLogin();
        }
      }).catch((err) => {
        goToLogin();
      });
    } else {
      goToLogin();
    }
  }

  const goToLogin = () => {
    window.location = '/login';
  }

  const getListSlide = async () => {
    axios.post(URL.list).then((res) => {
      if (res?.status === 200) {
        if (res?.data?.result === "complete") {
          setData(res?.data?.list?.allslides || []);
        } else {
          setIsError(true);
        }
      } else {
        setIsError(true);
      }
    }).catch((err) => {
      setIsError(true);
    });
  }

  const onClickEdit = (item) => {
    setItemEdit(item);
    setIsCreate(false);
  }

  const onClickDelete = (item) => {
    setItemDelete(item);
    setIsConfrim(true);
  }

  const onDelete = async () => {
    axios.post(URL.delete, { 
      ...itemDelete,
      requestaccess: getRequestAccess()
    }).then((res) => {
      setIsConfrim(false);
      setCounter(2);
      if (res?.status === 200) {
        if (res?.data?.result === "complete") {
          getListSlide();
          setIsSuccess(true);
        } else {
          setIsError(true);
        }
      } else {
        setIsError(true);
      }
    }).catch(error => {
      setIsConfrim(false);
      setCounter(2);
      setIsError(true);
    });
  }

  const onSaveSort = (newdata) => {
    newdata = newdata.sort((a, b) => (a.newslot||999) - (b.newslot || 999));

    let _list = [];
    let slot = 0;

    newdata.forEach((m) => {
      if (m.newslot) {
        slot = m.newslot;
      } else {
        slot = slot + 1;
      }
      m.slot = slot;
      delete m.newslot;
      _list.push(axios.post(URL.edit, { ...m, requestaccess: getRequestAccess() })); 
    })

    Promise.all(_list).then((values) => {
      setIsSuccess2(true);
      setCounter(2);
      setIsEditN(false);
      getListSlide();
    }).catch(error => {
      setIsError2(true);
      setCounter(2);
      setIsEditN(false);
      getListSlide();
    })
  }

  const onCancelSort = () => {
    let list = [];
    data.forEach((f) => {
      f.newslot = 0;
      list.push({ ...f });
    })
    setData([...data.sort((a, b) => a.slot - b.slot)]);
    setIsEditN(false);
  }

  useEffect(() => {
    if (counter > 0) {
      setTimeout(() => {
        setCounter(counter - 1);
      }, 1000)
    } else {
      setIsSuccess(false);
      setIsError(false);
    }
  }, [counter])

  const onLogout = () => {
    setDataInfo('');
    window.location = '/login';
  }

  if (openSlide) {
    return (<ShowItem           
      imagesList={data}
      open={openSlide}
      setOpenSlide={setOpenSlide}
    />)
  }

  return (
    <Box className="main">
      {isConfirm && (
        <ConfirmModal
          onClose={() => setIsConfrim(false)}
          onDelete={onDelete}
        />
      )}

      <Box sx={{ 
        display: 'flex',
        justifyContent:'space-between',
        alignItems: 'center',
        px: xs ? 2 : 4,
        py: 1,
        position: 'fixed',
        width: '100%',
        background: 'white',
        boxShadow: '0px 5px 5px -4px rgba(0, 0, 0, 0.3)',
        zIndex: 9999,
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <img src="/images/nosetea.svg" style={{ width: 'auto', height: '100%', maxHeight: xs ? '24px' : '34px', marginRight: 14 }} />
          <h2 style={xs ? { fontSize: '24px', color: '#738670', marginRight: '10px' } : { color: '#738670' }}>ระบบคิว (แอดมิน)</h2>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <p onClick={onLogout} style={{ cursor: 'pointer' }}>ออกจากระบบ</p>
        </Box>
      </Box>
      <Box style={{
        height: '100%',
        minHeight: '100vh',
        background: '#F9F9F9'
      }} className="header">
        <Box>
          <Grid container spacing={3} sx={{ }}>
            <Grid item xs={12} sm={12} md={5} lg={3} xl={3}>
              <FormItem 
                getListSlide={getListSlide}
                imagesList={[...data]}
                isCreate={isCreate}
                itemEdit={itemEdit}
                setIsCreate={setIsCreate}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={7} lg={9} xl={9}>
              {!isEditN && (
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                  <Box>
                    {isError && (
                      <Box>
                        <Alert severity="error" sx={{ alignItems: 'center', fontFamily: 'KIT65P', fontSize: '1.3rem' }}>เกิดข้อผิดพลาด ทำรายการไม่สำเร็จ</Alert>
                      </Box>
                    )}

                    {isSuccess && (
                      <Box>
                        <Alert severity="success" sx={{ alignItems: 'center', fontFamily: 'KIT65P', fontSize: '1.3rem' }}>ลบสำเร็จ</Alert>
                      </Box>
                    )}

                    {isError2 && (
                      <Box>
                        <Alert severity="error" sx={{ alignItems: 'center', fontFamily: 'KIT65P', fontSize: '1.3rem' }}>เกิดข้อผิดพลาด ทำรายการไม่สำเร็จ</Alert>
                      </Box>
                    )}

                    {isSuccess2 && (
                      <Box>
                        <Alert severity="success" sx={{ alignItems: 'center', fontFamily: 'KIT65P', fontSize: '1.3rem' }}>จัดเรียงรายการสำเร็จ</Alert>
                      </Box>
                    )}
                  </Box>
                  <Box>
                    <Button
                      onClick={() => setIsEditN(true)}
                      style={{ 
                        color: 'white',
                        fontFamily: 'KIT65P',
                        fontSize: '1.5rem',
                        padding: '2px 10px',
                        width: 220,
                        background: '#5F966C',
                        borderRadius: '16px',
                        marginRight: 14
                      }}
                    >
                      <img src="/images/reset2.svg" style={{ height: 18, width: 'auto', marginRight: 7 }} />
                      แก้ไขลำดับการแสดงผล</Button>

                    <Button
                      onClick={() => setOpenSlide(true)}
                      style={{ 
                        color: 'white',
                        fontFamily: 'KIT65P',
                        fontSize: '1.5rem',
                        padding: '2px 10px',
                        width: 100,
                        background: '#7BBA81',
                        borderRadius: '16px',
                      }}
                    >ดูตัวอย่าง</Button>
                  </Box>
                </Box>
              )}
              
              <ItemBox 
                imagesList={data}
                isEditN={isEditN}
                onSaveSort={onSaveSort}
                onCancelSort={onCancelSort}
                onClickEdit={onClickEdit}
                onClickDelete={onClickDelete}
              />
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
}


const ConfirmModal = ({ onClose, onDelete }) => {
  return (
    <Dialog open={true} fullWidth maxWidth="sm">
      <DialogContent sx={{
        background: 'rgba(115,134,112,0.9)',
        display: 'flex',
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '70px 30px',
      }}>
      <Box sx={{}}>
        <Box sx={{ position: 'absolute', top: 10, right: 14 }}>
          <p style={{ color: 'white', cursor: 'pointer' }} onClick={() => onClose()}>x ปิด</p>
        </Box>
        <Box>
          <h4 style={{ color: 'white' }}>ต้องการลบรูปภาพ / VDO</h4>
          <Box sx={{ mt: 3, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Button onClick={() => onDelete()} style={{ 
              color: '#656565',
              fontFamily: 'KIT65P',
              fontSize: '1.8rem',
              padding: '0px 40px',
              background: '#CFE2C9',
              marginRight: '20px',
              borderRadius: '16px'
            }}>ตกลง</Button>
            <Button onClick={() => onClose()} style={{ 
              color: '#656565',
              fontFamily: 'KIT65P',
              fontSize: '1.8rem',
              padding: '0px 40px',
              background: '#CFE2C9',
              borderRadius: '16px'
            }}
            >ยกเลิก</Button>
          </Box>
        </Box>
      </Box>
      </DialogContent>
    </Dialog>
  )
}

const ErrorModal = ({ onClose }) => {
  return (
    <Box sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: 99999,
      width: '100%',
      height: '100%',
      p: 1.5
    }}>
      <Box sx={{
        background: 'rgba(115,134,112,0.9)',
        width: '100%',
        height: '100%',
        display: 'flex',
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center'
      }}>
        <Box sx={{ position: 'absolute', top: 10, right: 14 }}>
          <p style={{ color: 'white', cursor: 'pointer' }} onClick={() => onClose()}>x ปิด</p>
        </Box>
        <Box>
          <img src="/images/wifi.png" style={{ width: 100, height: 'auto', marginBottom: 10 }} />
          <h4 style={{ color: 'white' }}>ขออภัย ระบบไม่สามารถส่งข้อมูลได้</h4>
          <h4 style={{ color: 'white' }}>เนื่องจากสัญญาณอินเตอร์เน็ตไม่เสถียร</h4>
          <h4 style={{ color: 'white' }}>กรุณาลองใหม่</h4>
        </Box>
      </Box>
    </Box>
  )
}

export default Home;
